import { Col, Divider, Row } from "antd";
import React from "react";
import { getTranslatedValue } from "../../utils/Utils";
import DoctorTimeCard from "../DoctorTimeCard";
import Container from "./Container";

const FifthBlock = ({ timeSaved }) => {
  const doctorTimeData = [
    {
      imageSrc: "/images/pot-1.svg",
      title: getTranslatedValue("doctorTimeLabel"),
      subTitle: getTranslatedValue("inAppointments"),
      timeSaved: Math.round(timeSaved?.doctor?.practice),
      timeSpent: Math.round(timeSaved?.doctor?.dm),
      netSavings: Math.round(timeSaved?.doctor?.netSaving),
    },
    {
      imageSrc: "/images/pot-2.svg",
      title: getTranslatedValue("staffTimeLabel"),
      subTitle: getTranslatedValue("inAppointments"),
      timeSaved: Math.round(timeSaved?.staff?.practice),
      timeSpent: Math.round(timeSaved?.staff?.dm),
      netSavings: Math.round(timeSaved?.staff?.netSaving),
    },
    {
      imageSrc: "/images/pot-3.svg",
      title: getTranslatedValue("patientTimeLabel"),
      subTitle: getTranslatedValue("onTreatment"),
      timeSaved: Math.round(timeSaved?.patient?.practice),
    },
  ];

  const children = (
    <Row gutter={16}>
      {doctorTimeData.map((item, index) => (
        <React.Fragment key={index}>
          <Col span={7}>
            <DoctorTimeCard
              imageSrc={item.imageSrc}
              title={item.title}
              subTitle={item.subTitle}
              timeSaved={item.timeSaved}
              timeSpent={item.timeSpent}
              netSavings={item.netSavings}
            />
          </Col>

          {index !== doctorTimeData.length - 1 && (
            <Col span={1}>
              <Divider type="vertical" className="roi--divider-vertical" />
            </Col>
          )}
        </React.Fragment>
      ))}
    </Row>
  );
  return (
    <Container
      blockTitle={"potentielTime"}
      title={"why"}
      content={"timeSavedInfo"}
      children={children}
    />
  );
};

export default FifthBlock;
